import * as React from 'react';
import Grid from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Copyright from '../internals/components/Copyright';
import ChartUserByCountry from '../components/ChartUserByCountry';
import CustomizedTreeView from '../components/CustomizedTreeView';
import CustomizedDataGrid from '../components/CustomizedDataGrid';
import HighlightedCard from '../components/HighlightedCard';
import PageViewsBarChart from '../components/PageViewsBarChart';
import SessionsChart from '../components/SessionsChart';
import StatCard from '../components/StatCard';
import MainMap from '../components/MainMap';
import ChartAssetsByType from '../components/ChartAssetsByType';

const data = [
  {
    title: 'Active Fleet',
    value: '24',
    interval: 'Last 30 days',
    data: [0, 3, 6, 9, 12, 10, 8, 11, 14, 12, 15, 20, 17, 19, 16, 18, 21, 24, 22, 25, 23, 20, 22, 24, 21, 23, 25, 26, 27],
  },
  {
    title: 'Active Packs',
    value: '152',
    interval: 'Last 30 days',
    data: [169, 120, 157, 88, 25, 30, 90, 88, 95, 38, 145, 150, 48, 55, 60, 128, 65, 70, 68, 75, 80, 78, 85, 90, 88, 95, 100, 110, 120, 152],
  },
  {
    title: 'Active Trackers',
    value: '0',
    interval: 'Last 30 days',
    data: Array(30).fill(0),
  },
];

export default function Home() {
  return (
    <Box sx={{ width: '100%', maxWidth: { sm: '100%', md: '1700px' } }}>
      {/* cards */}
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Overview
      </Typography>
      <Grid
        container
        spacing={2}
        columns={12}
        sx={{ mb: (theme) => theme.spacing(2) }}
      >
        {data.map((card, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, lg: 3 }}>
            <StatCard card={card} />
          </Grid>
        ))}
        <Grid size={{ xs: 12, sm: 6, lg: 3 }}>
          <HighlightedCard />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <SessionsChart />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <PageViewsBarChart />
        </Grid>
      </Grid>
      <Typography component="h2" variant="h6" sx={{ mb: 2 }}>
        Devices
      </Typography>
      <Grid container spacing={2} columns={12}>
        <Grid size={{ xs: 12, lg: 9 }} sx={{ overflow: 'hidden', borderRadius: '8px', border: '1px solid var(--template-palette-divider)' }}>
          {/* <CustomizedDataGrid /> */}
          <MainMap></MainMap>
        </Grid>
        <Grid size={{ xs: 12, lg: 3 }}>
          <Stack gap={2} direction={{ xs: 'column', sm: 'row', lg: 'column' }}>
            {/* <CustomizedTreeView /> */}
            {/* <ChartUserByCountry /> */}
            <ChartAssetsByType></ChartAssetsByType>
          </Stack>
        </Grid>
      </Grid>
      <Copyright sx={{ my: 4 }} />
    </Box>
  );
}
